<template>
  <el-pagination
    class="paginator"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageNum"
    :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
    :page-size="pageSize"
    :layout="small ? 'sizes,prev, pager, next' : layout"
    :total="total"
    :small="small"
  >
  </el-pagination>
</template>
<script>
/**
 *   分页组件
 */
export default {
  name: "Pagination",
  props: {
    pageSize: [Number, String],
    pageNum: [Number, String],
    total: [Number, String],
    layout: {
      // 分页的默认样式
      type: String,
      default: "total, prev, pager, next, jumper",  // 删了 sizes
    },
    small: Boolean, // 是否最小化
  },
  data() {
    return {};
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
// @import "../scss/variables";
// @import "../scss/mixins";
.el-pagination {
  text-align: right;
  padding: 8px 0;
}
.paginator.el-pagination.is-background {
  /*height: 35px;*/
  /*line-height: 0px;*/
  /*display: -webkit-box;*/
  /*display: -ms-flexbox;*/
  /*-ms-flex-align: center;*/
  /*align-items: center;*/
  /*background: #fff;*/
  /*border-radius: 4px;*/
  /*margin-top: 10px;*/
  /*text-align: right;*/
  /*display: list-item;*/
  /*align-items: center;*/
  /*.btn-next,*/
  /*.btn-prev,*/
  /*.el-pager li {*/
  /*background-color: #fff;*/
  /*height: 24px;*/
  /*min-width: 24px;*/
  /*line-height: 22px;*/
  /*border: 1px solid rgba(226, 226, 226, 1);*/
  /*border-radius: 4px;*/
  /*font-size: 12px;*/
  /*font-weight: 400;*/
  /*color: rgba(102, 102, 102, 1);*/
  /*padding: 0 2px;*/
  /*}*/
  /*.el-pager li:not(.disabled).active {*/
  /*background: #5397f7;*/
  /*}*/
}
</style>
